import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { trackPageview } from '../../utils/analytics';

/**
 * Composant invisible monté dans <Router>. Déclenche un pageview à chaque
 * changement de route. Le beacon côté client filtre les routes admin/auth.
 */
class AnalyticsTracker extends Component {
  componentDidMount() {
    trackPageview(this.props.location.pathname);
  }

  componentDidUpdate(prev) {
    if (prev.location.pathname !== this.props.location.pathname) {
      trackPageview(this.props.location.pathname);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(AnalyticsTracker);
